/* Sticky add-to-cart mobile OMINA.
   - Visible uniquement quand la zone d'achat principale n'est plus à l'écran.
   - Se synchronise avec le variant actif via les événements Dawn (pubsub) et
     soumet le formulaire produit principal (ajout AJAX Dawn standard). */
if (!customElements.get('omina-sticky-atc')) {
  customElements.define(
    'omina-sticky-atc',
    class OminaStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.formId = this.dataset.formId;
        this.submitButton = this.querySelector('[data-sticky-submit]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.labelEl = this.querySelector('[data-sticky-label]');

        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.submitMainForm.bind(this));
        }

        this.observeBuyButtons();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.onVariantChange.bind(this)
          );
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () =>
            this.setLoading(false)
          );
          this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () =>
            this.setLoading(false)
          );
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.variantUnsubscriber) this.variantUnsubscriber();
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.cartErrorUnsubscriber) this.cartErrorUnsubscriber();
      }

      observeBuyButtons() {
        const buyButtons = document.querySelector(
          `#MainProduct-${this.sectionId} .product-form__buttons`
        );
        if (!buyButtons || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const showSticky = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', showSticky);
              this.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
              if (this.submitButton) {
                this.submitButton.tabIndex = showSticky ? 0 : -1;
              }
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(buyButtons);
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;
        const variant = event.data.variant;

        if (!variant) {
          this.updateState(window.variantStrings.unavailable, true, null);
          return;
        }

        const price = this.formatPriceFromDom();
        if (variant.available) {
          this.updateState(window.variantStrings.addToCart, false, price);
        } else {
          this.updateState(window.variantStrings.soldOut, true, price);
        }
      }

      /* Recopie le prix affiché par Dawn (déjà formaté et localisé par Shopify)
         plutôt que de reformater un montant côté client. */
      formatPriceFromDom() {
        const priceContainer = document.getElementById(`price-${this.sectionId}`);
        if (!priceContainer) return null;
        const priceItem = priceContainer.querySelector(
          '.price__sale .price-item--sale, .price__regular .price-item--regular'
        );
        return priceItem ? priceItem.textContent.trim() : null;
      }

      updateState(label, disabled, price) {
        if (this.labelEl && label) this.labelEl.textContent = label;
        if (this.submitButton) this.submitButton.disabled = disabled;
        if (this.priceEl && price) this.priceEl.textContent = price;
      }

      submitMainForm() {
        const form = document.getElementById(this.formId);
        if (!form) return;
        this.setLoading(true);
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;
        this.submitButton.classList.toggle('loading', isLoading);
        this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        const spinner = this.submitButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
      }
    }
  );
}
